export enum TransactionStatus {
  Registered = 'Registered',
  Pending = 'Pending',
  Paid = 'Paid',
  Inactive = 'Inactive',
}

export enum TransferMateResponseContext {
  REFUND = 'REFUND',
  '3RDPTY' = '3RDPTY',
  TRANSACTION = 'TRANSACTION',
}

export interface TransferMatePayment {
  orderId: string;
  transactionId: string;
  responseContext: TransferMateResponseContext;
  eventType: string;
  paymentMethod: string;
  refNumber: string;
  transactionStatusId: string;
  transactionStatus: TransactionStatus;
  payableAmount: string;
  payableCurrency: string;
  paidCurrency: string;
  paidAmount: string;
  pendingDate: string;
  paidDate: string;
  registeredDate: string;
}

export interface StudentTransferMatePayments {
  uni: string;
  studentNo: string;
  payments: TransferMatePayment[];
}
